/* Gift guide (kits) — sections/gift-guide-kits.liquid.
   The page is fully rendered by Liquid and every Add is a real /cart/add
   form; this file only adds the interactions from the approved mockup:
   the finder filter, the kit picker, the TrickStarters total, the deck tray,
   the gift card amount, tap-to-play, and the desktop hover preview.
   Cart lines go through window.TOMSCart.addItems (theme.js), which posts
   them in one request, refreshes the drawer, updates the count and opens it. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ggk]');
  if (!root) return;

  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var thr = Number(root.dataset.thr) || 0;
  var strip = root.dataset.strip === '1';
  function $(sel, el) { return (el || root).querySelector(sel); }
  function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function json(sel) { var el = $(sel); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function money(c) {
    var m = window.TOMSCart && window.TOMSCart.money ? window.TOMSCart.money(Math.round(c)) : '$' + (Math.round(c) / 100).toFixed(2);
    return strip ? m.replace(/([.,]00)(?!\d)/, '') : m;
  }
  function fill(t, map) { return String(t || '').replace(/\[(\w+)\]/g, function (a, k) { return k in map ? map[k] : a; }); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  var W = json('[data-gk-words]');

  /* ---------- Add to bag: every [data-gk-form] ---------- */
  function linesOf(form) {
    var id = form.querySelector('[name="id"]:checked') || form.querySelector('input[type="hidden"][name="id"]');
    if (id) return [{ id: Number(id.value), quantity: 1 }];
    return $$('input[name="items[][id]"]:checked', form).map(function (i) { return { id: Number(i.value), quantity: 1 }; });
  }
  root.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-gk-form]');
    if (!form || !window.TOMSCart || !window.TOMSCart.addItems) return; /* no theme cart: post the form */
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var items = linesOf(form);
    if (!items.length || (btn && btn.disabled)) return;
    var label = btn ? btn.innerHTML : '';
    window.TOMSCart.addItems(items, btn).then(function (cart) {
      if (!cart || !btn) return;
      btn.textContent = W.added || '✓ Added';
      btn.classList.add('gk-done');
      setTimeout(function () { btn.innerHTML = label; btn.classList.remove('gk-done'); }, 2200);
    });
  });

  /* ---------- Gift finder ---------- */
  var grid = $('[data-gk-grid]');
  if (grid) {
    var gifts = $$('[data-gk-gift]', grid);
    var gcTile = $('[data-gk-gctile]', grid);
    var empty = $('[data-gk-empty]', grid);
    var infoTile = $('[data-gk-info]', grid);
    var stat = $('[data-gk-stat]');
    var clearBtn = $('[data-gk-clear]');
    var moreBtn = $('[data-gk-more]');
    var whoBtns = $$('[data-gk-whos] [data-who]');
    var budBtns = $$('[data-gk-buds] [data-bud]');
    var PAGE = Number(root.dataset.page) || 8;
    var gcMin = Number(root.dataset.gcmin) || 0;
    var ST = { who: null, bud: null, all: false };
    var favs = gifts.filter(function (g) { return g.hasAttribute('data-fav'); });

    var budOf = function (k) { return budBtns.filter(function (b) { return b.dataset.bud === k; })[0]; };
    var whoOf = function (k) { return whoBtns.filter(function (b) { return b.dataset.who === k; })[0]; };
    var match = function (g) {
      var b = ST.bud && budOf(ST.bud), p = Number(g.dataset.price);
      return (!ST.who || g.dataset.who.indexOf(' ' + ST.who + ' ') > -1) &&
        (!b || (p >= Number(b.dataset.min) && p < Number(b.dataset.max)));
    };
    var render = function (animate) {
      var filtered = !!(ST.who || ST.bud);
      var list = filtered ? gifts.filter(match) : (ST.all ? gifts : favs);
      var shown = (filtered && !ST.all && list.length > PAGE + 2) ? list.slice(0, PAGE) : list;
      var i = 0;
      gifts.forEach(function (g) {
        var on = shown.indexOf(g) > -1;
        g.hidden = !on;
        g.classList.remove('is-last-odd');
        if (on && animate && !reduce) {
          g.classList.remove('gk-in'); void g.offsetWidth;
          g.style.animationDelay = (i * 35) + 'ms'; g.classList.add('gk-in');
        }
        if (on) i++;
      });
      grid.classList.toggle('is-filtered', filtered);
      var b = ST.bud && budOf(ST.bud);
      var gcOn = !!gcTile && filtered && list.length < 4 && (!b || gcMin < Number(b.dataset.max));
      if (gcTile) {
        gcTile.hidden = !gcOn;
        gcTile.classList.remove('is-last-odd');
        if (gcOn && animate && !reduce) { gcTile.classList.remove('gk-in'); void gcTile.offsetWidth; gcTile.classList.add('gk-in'); }
      }
      if (empty) empty.hidden = !(filtered && list.length === 0 && !gcOn);
      /* The shipping + Pip tile closes the grid; not under an empty result. */
      var infoOn = !!infoTile && (list.length > 0 || gcOn);
      if (infoTile) { infoTile.hidden = !infoOn; infoTile.classList.remove('is-last-odd'); }
      /* Phone: an odd last card spans the row (mockup rule, done by class
         because hidden cards still count for :last-child). */
      var vis = shown.slice(); if (gcOn) vis.push(gcTile); if (infoOn) vis.push(infoTile);
      if (vis.length % 2 === 1) vis[vis.length - 1].classList.add('is-last-odd');

      var n = list.length, txt;
      if (!filtered) {
        txt = ST.all ? esc(fill(W.all, { n: gifts.length }))
          : esc(fill(W.favs, { n: favs.length })) + ' <span>' + esc(fill(W.of, { n: gifts.length })) + '</span>';
      } else {
        var parts = [];
        if (ST.who) parts.push(whoOf(ST.who).dataset.phrase);
        if (ST.bud) parts.push(b.dataset.phrase);
        var phr = esc(parts.join(' '));
        txt = n ? esc(n === 1 ? W.one : fill(W.count, { n: n })) + ' <span>' + phr + '</span>'
          : esc(W.none) + ' ' + phr + ' <span>yet</span>';
      }
      stat.innerHTML = txt;
      clearBtn.hidden = !filtered;
      var label = null;
      if (!filtered && !ST.all) label = fill(W.seeAll, { n: gifts.length });
      else if (filtered && !ST.all && list.length > PAGE + 2) label = fill(W.more, { n: list.length - PAGE });
      else if (ST.all && !filtered) label = W.back;
      if (favs.length === gifts.length && !filtered) label = null;
      moreBtn.hidden = !label;
      if (label) moreBtn.textContent = label;
      moreBtn.parentNode.hidden = !label;
      whoBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.who === ST.who)); });
      budBtns.forEach(function (x) { x.setAttribute('aria-pressed', String(x.dataset.bud === ST.bud)); });
    };
    whoBtns.forEach(function (b) { b.addEventListener('click', function () { ST.who = ST.who === b.dataset.who ? null : b.dataset.who; ST.all = false; render(true); }); });
    budBtns.forEach(function (b) { b.addEventListener('click', function () { ST.bud = ST.bud === b.dataset.bud ? null : b.dataset.bud; ST.all = false; render(true); }); });
    clearBtn.addEventListener('click', function () { ST.who = ST.bud = null; ST.all = false; render(true); });
    moreBtn.addEventListener('click', function () { ST.all = !ST.all; render(true); });
    $$('[data-gk-jump]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        ST.who = a.dataset.gkJump; ST.bud = null; ST.all = false; render(true);
        var sec = document.getElementById('gk-who');
        if (sec) sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
      });
    });
    render(false);
  }

  /* ---------- Kits: segmented control ---------- */
  var seg = $('[data-gk-seg]');
  if (seg) {
    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      var k = b.dataset.k;
      $$('button', seg).forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
      $$('[data-gk-kits] .gk-kt').forEach(function (a) { a.classList.toggle('gk-on', a.dataset.k === k); });
      if (window.innerWidth < 900) {
        var on = $('[data-gk-kits] .gk-kt.gk-on'); var r = on.getBoundingClientRect();
        if (r.top < 120 || r.top > window.innerHeight * 0.6) on.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });
    seg.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var bs = $$('button', seg), i = bs.indexOf(document.activeElement); if (i < 0) return;
      var n = bs[(i + (e.key === 'ArrowRight' ? 1 : bs.length - 1)) % bs.length];
      n.focus(); n.click(); e.preventDefault();
    });
  }

  /* ---------- TrickStarters picker ---------- */
  var ts = $('[data-gk-ts]');
  if (ts) {
    var TW = json('[data-gk-ts-words]');
    var boxes = $$('input[type="checkbox"]', ts);
    var word = function (n) { return (TW.words && TW.words[n]) || String(n); };
    var tsRender = function () {
      var on = boxes.filter(function (b) { return b.checked; });
      var n = on.length, all = n === boxes.length;
      var tot = on.reduce(function (a, b) { return a + Number(b.dataset.price); }, 0);
      var lbl = all ? 'All ' + word(n) : n === 1 ? '1 trick' : n + ' tricks';
      $('[data-gk-ts-tot]', ts).textContent = n ? lbl + ', ' + money(tot) : (TW.none || '');
      var sp = $('[data-gk-ts-ship]', ts);
      if (!n) { sp.textContent = fill('[each] each', { each: TW.each }); sp.className = 'gk-sp gk-no'; }
      else if (thr && tot >= thr) { sp.textContent = TW.shipsFree; sp.className = 'gk-sp'; }
      else if (thr) { sp.textContent = fill(TW.gap, { amount: money(thr - tot) }); sp.className = 'gk-sp gk-no'; }
      else { sp.textContent = ''; sp.className = 'gk-sp gk-no'; }
      var b = $('[data-gk-ts-add]', ts);
      b.disabled = !n; b.style.opacity = n ? 1 : 0.45;
      b.textContent = all ? 'Add all ' + word(n) + ' · ' + money(tot) : n ? 'Add ' + lbl + ' · ' + money(tot) : 'Add';
      $('[data-gk-ts-toggle]', ts).textContent = all ? TW.clear : fill(TW.selectAll, { all: 'all ' + word(boxes.length) });
    };
    boxes.forEach(function (b) { b.addEventListener('change', tsRender); });
    $('[data-gk-ts-toggle]', ts).addEventListener('click', function () {
      var all = boxes.every(function (b) { return b.checked; });
      boxes.forEach(function (b) { b.checked = !all; }); tsRender();
    });
    tsRender();
  }

  /* Tap to play: the clip loads only now, with sound and controls. */
  var vidBtn = $('[data-gk-video]');
  if (vidBtn && vidBtn.dataset.src) {
    vidBtn.addEventListener('click', function () {
      if (vidBtn.querySelector('video')) return;
      var v = document.createElement('video');
      v.src = vidBtn.dataset.src; v.controls = true; v.playsInline = true; v.autoplay = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('aria-label', vidBtn.getAttribute('aria-label') || '');
      vidBtn.appendChild(v);
      var p = v.play && v.play(); if (p && p.catch) p.catch(function () {});
    });
  }

  /* ---------- Deck tray ---------- */
  var dk = $('[data-gk-decks]');
  if (dk) {
    var DW = json('[data-gk-deck-words]');
    var T = [Number(dk.dataset.t1), Number(dk.dataset.t2), Number(dk.dataset.t3)];
    var P = [Number(dk.dataset.p1), Number(dk.dataset.p2), Number(dk.dataset.p3)];
    var decks = $$('[data-gk-deck]', dk);
    var order = decks.filter(function (d) { return d.querySelector('input').checked; });
    var dRender = function () {
      var n = order.length;
      var tier = n >= T[2] ? 2 : n >= T[1] ? 1 : n >= T[0] ? 0 : -1;
      var pct = tier < 0 ? 0 : P[tier];
      var full = order.reduce(function (a, d) { return a + Number(d.querySelector('input').dataset.price); }, 0);
      var est = Math.round(full * (1 - pct / 100));
      var slots = Math.max(T[0], n < T[1] ? (n >= T[0] ? T[1] : T[0]) : n), h = '';
      for (var s = 0; s < slots; s++) {
        var d = order[s];
        if (d) { var im = d.querySelector('img'); h += '<i class="gk-f"><img src="' + esc(im ? im.currentSrc || im.src : '') + '" alt=""></i>'; }
        else h += '<i></i>';
      }
      $('[data-gk-slots]', dk).innerHTML = h;
      var next = n < T[0] ? T[0] : n < T[1] ? T[1] : T[2], msg;
      if (n === 0) msg = fill(DW.start, { t: T[0], p: P[0] });
      else if (n < T[0]) msg = fill(DW.some, { n: n, t: T[0], k: T[0] - n, p: P[0] });
      else {
        msg = fill(DW.applied, { p: pct });
        if (n > T[0] && n < T[1]) msg += fill(DW.next, { k: T[1] - n, p: P[1] });
      }
      var m = $('[data-gk-msg]', dk); m.textContent = msg; m.className = 'gk-msg' + (pct ? ' gk-ok' : '');
      var bar = $('[data-gk-bar]', dk);
      bar.firstElementChild.style.width = Math.min(100, n / next * 100) + '%';
      bar.className = 'gk-bar' + (pct ? ' gk-ok' : '');
      $('[data-gk-dtot]', dk).innerHTML = n ? (pct ? '<s>' + esc(money(full)) + '</s>' + esc(money(est)) + '<small>' + esc(DW.est || '') + '</small>' : esc(money(full))) : '';
      var b = $('[data-gk-dadd]', dk);
      b.disabled = !n; b.style.opacity = n ? 1 : 0.45;
      b.textContent = n > 1 ? fill(DW.add, { n: n }) : n === 1 ? DW.addOne : DW.addNone;
    };
    decks.forEach(function (d) {
      var input = d.querySelector('input');
      input.addEventListener('change', function () {
        var k = order.indexOf(d);
        if (input.checked && k < 0) order.push(d);
        if (!input.checked && k > -1) order.splice(k, 1);
        dRender();
      });
      var sel = d.querySelector('[data-gk-dv]');
      if (sel) {
        sel.addEventListener('click', function (e) { e.stopPropagation(); });
        sel.addEventListener('change', function () {
          var o = sel.options[sel.selectedIndex];
          input.value = o.value; input.dataset.price = o.dataset.price; dRender();
        });
      }
    });
    dRender();
  }

  /* ---------- Gift card: live card preview ----------
     Chips are the gift card's variants; the checked one is what the form
     posts. The recipient fields carry Shopify's own gift card properties
     (same names as the gift card product page), only when an email is given;
     left blank, it is an ordinary gift card in the buyer's bag. */
  var gcf = $('[data-gk-gc]');
  if (gcf) {
    var GW = json('[data-gk-gc-words]');
    var card = $('[data-gk-gccard]', gcf);
    var amt = $('[data-gk-amt]', gcf), gbtn = $('[data-gk-gcadd]', gcf);
    var amts = $('[data-gk-amts]', gcf), amore = $('[data-gk-amore]', gcf);
    var to = $('[data-gk-to]', gcf);
    var tName = $('[data-gk-to-name]', gcf), tEmail = $('[data-gk-to-email]', gcf);
    var tMsg = $('[data-gk-to-msg]', gcf), tDate = $('[data-gk-to-date]', gcf);
    var tCount = $('[data-gk-to-count]', gcf), tNote = $('[data-gk-to-note]', gcf), tErr = $('[data-gk-to-err]', gcf);
    var cFor = $('[data-gk-gcfor]', gcf), cMsg = $('[data-gk-gcmsg]', gcf);
    var extras = $$('[data-gk-extra]', amts);

    /* "Other amounts": the listed chips first, every amount on request. */
    if (extras.length) {
      var extraOn = extras.some(function (l) { return l.querySelector('input').checked; });
      amore.hidden = false;
      var setOpen = function (open) { amts.classList.toggle('is-closed', !open); amore.setAttribute('aria-expanded', String(open)); };
      setOpen(extraOn);
      amore.addEventListener('click', function () { setOpen(amts.classList.contains('is-closed')); });
    }
    $$('input[name="id"]', amts).forEach(function (r) {
      r.addEventListener('change', function () {
        if (!r.checked) return;
        gbtn.textContent = fill(gbtn.dataset.tpl, { amount: r.dataset.label });
        /* the shared card (assets/gift-card-art.js): new amount pops, the card turns */
        if (window.TOMSGiftCard) window.TOMSGiftCard.set(card, { amount: r.dataset.label, flip: true });
        else amt.textContent = r.dataset.label;
        /* other currencies: "You’ll pay about $72.69 CAD at checkout. The card holds $50 USD." */
        var payAmt = $('[data-gcpay-amt]', gcf), payFace = $('[data-gcpay-face]', gcf);
        if (payAmt && r.dataset.pay) payAmt.textContent = r.dataset.pay;
        if (payFace) payFace.textContent = r.dataset.label;
      });
    });

    to.hidden = false;
    var fmtDate = function (v) {
      var p = v.split('-'); if (p.length !== 3) return v;
      try { return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString(document.documentElement.lang || 'en-CA', { month: 'long', day: 'numeric' }); } catch (e) { return v; }
    };
    var trim = function (s, n) { s = s.replace(/\s+/g, ' ').trim(); return s.length > n ? s.slice(0, n - 1).trim() + '…' : s; };
    var paint = function () {
      var n = tName.value.trim(), m = tMsg.value;
      var fn = n ? trim(n, 28) : '', fm = m.trim() ? trim(m, 80) : '';
      if (window.TOMSGiftCard) window.TOMSGiftCard.set(card, { forName: fn, forWord: GW.forWord || 'For', message: fm });
      else {
        cFor.hidden = !fn; cFor.textContent = fn ? (GW.forWord || 'For') + ' ' + fn : '';
        cMsg.hidden = !fm; cMsg.textContent = fm ? '\u201C' + fm + '\u201D' : '';
      }
      tCount.textContent = m.length;
      var e = tEmail.value.trim();
      tNote.textContent = !e ? tNote.dataset.me : tDate.value ? fill(tNote.dataset.themDate, { date: fmtDate(tDate.value) }) : tNote.dataset.them;
    };
    [tName, tEmail, tMsg, tDate].forEach(function (f) { f.addEventListener('input', paint); f.addEventListener('change', paint); });
    var showErr = function (msg, field) {
      tErr.textContent = msg; tErr.hidden = !msg;
      tEmail.setAttribute('aria-invalid', msg ? 'true' : 'false');
      if (field) field.focus();
    };
    tEmail.addEventListener('blur', function () {
      if (tEmail.value.trim() && !tEmail.checkValidity()) showErr(GW.errEmail, null);
      else if (!tErr.hidden) showErr('', null);
    });
    var clearTo = function () { [tName, tEmail, tMsg, tDate].forEach(function (f) { f.value = ''; }); paint(); };

    gcf.addEventListener('submit', function (e) {
      var chosen = $('input[name="id"]:checked', amts);
      var email = tEmail.value.trim(), any = tName.value.trim() || tMsg.value.trim() || tDate.value;
      if (email && !tEmail.checkValidity()) { e.preventDefault(); showErr(GW.errEmail, tEmail); return; }
      if (!email && any) { e.preventDefault(); showErr(GW.errNeed, tEmail); return; }
      showErr('', null);
      if (!window.TOMSCart || !window.TOMSCart.addItems || !chosen) return; /* plain post: an ordinary gift card */
      e.preventDefault();
      var item = { id: Number(chosen.value), quantity: 1 };
      if (email) {
        var pr = { '__shopify_send_gift_card_to_recipient': 'on', 'Recipient email': email };
        if (tName.value.trim()) pr['Recipient name'] = tName.value.trim();
        if (tMsg.value.trim()) pr['Message'] = tMsg.value.trim().slice(0, 200);
        if (tDate.value) pr['Send on'] = tDate.value;
        pr['__shopify_offset'] = String(new Date().getTimezoneOffset());
        item.properties = pr;
      }
      var label = gbtn.innerHTML;
      window.TOMSCart.addItems([item], gbtn).then(function (cart) {
        if (!cart) return;
        if (email) clearTo();
        gbtn.textContent = W.added || '✓ Added'; gbtn.classList.add('gk-done');
        setTimeout(function () { gbtn.innerHTML = label; gbtn.classList.remove('gk-done'); }, 2200);
      });
    });
    paint();
  }

  /* ---------- Gift card jump links (hero tile, finder tile, strip) ----------
     Scroll to the gift card section, then the card swings in once it is on
     screen (assets/gift-card-art.js). The old #gk-gift-card anchor still works. */
  var gcSec = document.getElementById('gift-card');
  if (gcSec) {
    var gcCard = gcSec.querySelector('[data-gccard]');
    var land = function () {
      if (!gcCard || reduce || !window.TOMSGiftCard) return;
      if (!('IntersectionObserver' in window)) { window.TOMSGiftCard.arrive(gcCard); return; }
      var io = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () { window.TOMSGiftCard.arrive(gcCard); }, 120);
      }, { threshold: 0.6 });
      io.observe(gcCard);
    };
    var jump = function () {
      gcSec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      land();
    };
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href="#gift-card"], a[href="#gk-gift-card"]');
      if (!a) return;
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', '#gift-card');
      jump();
    });
    if (location.hash === '#gift-card' || location.hash === '#gk-gift-card') setTimeout(jump, 300);
  }

  /* ---------- Desktop hover preview ----------
     Mouse/trackpad only, never on touch, never with reduced motion. The
     clip is created on hover (nothing preloads), muted, from the product's
     money shot (data-start) looping to data-end when it is set. */
  var canHover = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (canHover && !reduce) {
    $$('[data-clip]').forEach(function (box) {
      if (box.closest('[data-gk-tile]')) return; /* TrickStarters tiles: below */
      var card = box.closest('.gk-g, .gk-kt, .gk-bc') || box;
      var timer = null, v = null;
      var start = Number(box.dataset.start) || 0, end = Number(box.dataset.end) || 0;
      var stop = function () {
        clearTimeout(timer);
        box.classList.remove('is-playing');
        if (v) { v.pause(); }
      };
      card.addEventListener('mouseenter', function () {
        timer = setTimeout(function () {
          if (!v) {
            v = document.createElement('video');
            v.className = 'gk-clip';
            v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = !end;
            v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
            v.preload = 'auto';
            v.src = box.dataset.clip + (start ? '#t=' + start : '');
            v.addEventListener('loadedmetadata', function () { if (start && v.currentTime < start - 0.5) v.currentTime = start; });
            v.addEventListener('playing', function () { if (box.matches(':hover') || card.matches(':hover')) box.classList.add('is-playing'); });
            v.addEventListener('timeupdate', function () { if (end && v.currentTime >= end) v.currentTime = start; });
            v.addEventListener('ended', function () { v.currentTime = start; v.play().catch(function () {}); });
            box.appendChild(v);
          } else if (v.currentTime < start || (end && v.currentTime >= end)) {
            v.currentTime = start;
          }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
          if (!v.paused && v.readyState > 2) box.classList.add('is-playing');
        }, 120);
      });
      card.addEventListener('mouseleave', stop);
    });
  }

  /* ---------- TrickStarters tiles: Zach's clip in the tile ----------
     Each tile's play button plays that trick's demo inline, muted with a
     sound toggle, from the reveal (data-start) looping to data-end. One clip
     at a time. Nothing loads until play (or a desktop hover). The picture
     and words select; the buttons sit outside the label, so the two never
     trigger each other. Hover previews follow the cards above: mouse only,
     never with reduced motion. */
  var tiles = $$('[data-gk-tile]').filter(function (t) { return t.querySelector('[data-clip]'); });
  if (tiles.length) {
    var active = null;
    var TS = tiles.map(function (tile) {
      var box = tile.querySelector('[data-clip]');
      var playBtn = tile.querySelector('[data-gk-tplay]');
      var sndBtn = tile.querySelector('[data-gk-tsnd]');
      var start = Number(box.dataset.start) || 0, end = Number(box.dataset.end) || 0;
      var o = { tile: tile, v: null, mode: null, timer: null };
      var video = function () {
        if (o.v) return o.v;
        var v = o.v = document.createElement('video');
        v.className = 'gk-clip';
        v.muted = true; v.defaultMuted = true; v.playsInline = true; v.loop = !end;
        v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('aria-hidden', 'true');
        v.preload = 'auto';
        v.src = box.dataset.clip + (start ? '#t=' + start : '');
        v.addEventListener('loadedmetadata', function () { if (start && Math.abs(v.currentTime - start) > 0.5) v.currentTime = start; });
        v.addEventListener('playing', function () { if (o.mode) box.classList.add('is-playing'); });
        v.addEventListener('timeupdate', function () { if (end && v.currentTime >= end) v.currentTime = start; });
        v.addEventListener('ended', function () { v.currentTime = start; v.play().catch(function () {}); });
        box.appendChild(v);
        return v;
      };
      o.play = function (mode) {
        clearTimeout(o.timer);
        if (active && active !== o) active.stop();
        active = o; o.mode = mode;
        var v = video();
        if (v.readyState >= 1 && (v.currentTime < start - 0.5 || (end && v.currentTime >= end) || mode === 'tap')) v.currentTime = start;
        v.muted = !(mode === 'tap' && sndBtn.getAttribute('aria-pressed') === 'true');
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        if (!v.paused && v.readyState > 2) box.classList.add('is-playing');
        if (mode === 'tap') {
          tile.classList.add('is-on');
          playBtn.setAttribute('aria-label', playBtn.dataset.stop);
          sndBtn.hidden = false;
        }
      };
      o.stop = function () {
        clearTimeout(o.timer);
        o.mode = null;
        box.classList.remove('is-playing');
        tile.classList.remove('is-on');
        playBtn.setAttribute('aria-label', playBtn.dataset.play);
        sndBtn.hidden = true;
        if (o.v) { o.v.pause(); o.v.muted = true; }
        if (active === o) active = null;
      };
      playBtn.hidden = false;
      playBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (o.mode === 'tap') o.stop(); else o.play('tap');
      });
      sndBtn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var on = sndBtn.getAttribute('aria-pressed') !== 'true';
        sndBtn.setAttribute('aria-pressed', String(on));
        if (o.v) o.v.muted = !on;
      });
      if (canHover && !reduce) {
        tile.addEventListener('mouseenter', function () {
          if (o.mode === 'tap' || (active && active.mode === 'tap')) return;
          o.timer = setTimeout(function () {
            if (o.mode === 'tap' || (active && active.mode === 'tap')) return; /* a tap won the race */
            o.play('hover');
          }, 120);
        });
        tile.addEventListener('mouseleave', function () {
          clearTimeout(o.timer);
          if (o.mode === 'hover') o.stop();
        });
      }
      return o;
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden && active) active.stop(); });
  }
})();
